(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const scrollToSlide = (track, slide) => {
    track.scrollTo({ left: slide.offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  };

  document.querySelectorAll('[data-shop-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-shop-gallery-track]');
    if (!track) return;

    const step = (direction) => {
      track.scrollBy({ left: direction * track.clientWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };

    gallery.querySelector('[data-shop-gallery-previous]')?.addEventListener('click', () => step(-1));
    gallery.querySelector('[data-shop-gallery-next]')?.addEventListener('click', () => step(1));
  });

  document.querySelectorAll('[data-buy-models]').forEach((models) => {
    const price = models.closest('.bugass-buy-box')?.querySelector('[data-buy-price]');

    models.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.name !== 'id') return;

      if (price && input.dataset.price) price.textContent = input.dataset.price;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url);

      const track = document.querySelector('[data-shop-gallery-track]');
      const slide = input.dataset.mediaId && track?.querySelector(`[data-media-id="${input.dataset.mediaId}"]`);
      if (slide) scrollToSlide(track, slide);
    });
  });
})();
